/* src/app/app.component.css */
.records {
  margin-bottom: 2px;
}
/*# sourceMappingURL=app.component.css.map */
